<form class="ir-modal th-modal" #form="ngForm">
  <div class="ir-modal--title">
    <div class="ir-line--right">
      <div class="ir-btn th-btn-modal" (click)="selfModal.close()"><i class="material-icons">close</i></div>
    </div>
    <div class="ir-line">
      <div class="ir-line-content">
        <span>{{ 'inspections.filter.select-your-filters' | translate }}</span>
      </div>
    </div>
  </div>
  <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
    <div class="ir-content--modal th-content">
      <table class="ir-modal-table">
        <tr>
          <td class="margin">
            <span>{{ 'inspections.filter.fst-name' | translate }}</span>
          </td>
          <td class="margin">
            <div class="ir-form-group">
              <input type="hidden" name="fst" class="ir-form-set" [(ngModel)]="filter.fst" />
              <div class="ir-line ir-select th-select" (click)="openPeopleSelector()">
                <div class="ir-line--right">
                  <div class="ir-btn th-btn-modal--content">
                    <i class="material-icons">arrow_drop_down</i>
                  </div>
                </div>
                <div class="ir-line-content">
                  <span>{{ selectedPerson?.name || ('inspections.filter.select-value' | translate) }}</span>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="margin">
            <span>{{ 'inspections.filter.status' | translate }}</span>
          </td>
          <td class="margin">
            <div class="ir-form-group">
              <input type="hidden" name="status" class="ir-form-set" [(ngModel)]="filter.status" />
              <div class="ir-line ir-select th-select" (click)="openStatusSelector()">
                <div class="ir-line--right">
                  <div class="ir-btn th-btn-modal--content">
                    <i class="material-icons">arrow_drop_down</i>
                  </div>
                </div>
                <div class="ir-line-content">
                  <span>{{
                    filter.status || filter.status === 0 ? (filter.status | inspectionstatus) : ('inspections.filter.select-value' | translate)
                  }}</span>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="margin">
            <span>{{ 'inspections.filter.product-line' | translate }}</span>
          </td>
          <td class="margin">
            <div class="ir-form-group">
              <input type="hidden" name="productLineId" class="ir-form-set" [(ngModel)]="filter.productLine" />
              <div class="ir-line ir-select th-select" (click)="openProductLinesSelector()">
                <div class="ir-line--right">
                  <div class="ir-btn th-btn-modal--content">
                    <i class="material-icons">arrow_drop_down</i>
                  </div>
                </div>
                <div class="ir-line-content">
                  <span>{{
                    filter.productLine
                      ? (filter.productLine | productline | async)
                      : ('inspections.filter.select-value' | translate)
                  }}</span>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="margin">
            <span>{{ 'inspections.filter.local-entity' | translate }}</span>
          </td>
          <td class="margin">
            <div class="ir-form-group">
              <input type="hidden" name="localEntity" class="ir-form-set" [(ngModel)]="filter.localEntity" />
              <div class="ir-line ir-select th-select" (click)="openLocalEntitiesSelector()">
                <div class="ir-line--right">
                  <div class="ir-btn th-btn-modal--content">
                    <i class="material-icons">arrow_drop_down</i>
                  </div>
                </div>
                <div class="ir-line-content">
                  <span>{{ filter.localEntity ? (filter.localEntity | localEntity) : ('inspections.filter.select-value' | translate) }}</span>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="margin">
            <span>{{ 'inspections.filter.from' | translate }}</span>
          </td>
          <td class="margin">
            <div class="ir-form-group">
              <input
                type="date"
                name="from"
                [(ngModel)]="filter.from"
                class="ir-form-set"
                [max]="filter.to | inputDate"
              />
            </div>
          </td>
        </tr>
        <tr>
          <td class="margin">
            <span>{{ 'inspections.filter.to' | translate }}</span>
          </td>
          <td class="margin">
            <div class="ir-form-group">
              <input
                type="date"
                name="to"
                [(ngModel)]="filter.to"
                class="ir-form-set"
                [min]="filter.from | inputDate"
              />
            </div>
          </td>
        </tr>
        <tr>
          <td class="margin">
            <span>{{ 'inspections.filter.equipment-type' | translate }}</span>
          </td>
          <td class="margin">
            <div class="ir-form-group">
              <input type="hidden" name="equipmentType" class="ir-form-set" [(ngModel)]="filter.equipmentType" />
              <div class="ir-line ir-select th-select" (click)="openEuqipmentTypeSelector()">
                <div class="ir-line--right">
                  <div class="ir-btn th-btn-modal--content">
                    <i class="material-icons">arrow_drop_down</i>
                  </div>
                </div>
                <div class="ir-line-content">
                  <span>{{ filter.equipmentType || ('inspections.filter.select-value' | translate) }}</span>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="margin">
            <span>{{ 'inspections.filter.equipment-number' | translate }}</span>
          </td>
          <td class="margin">
            <div class="ir-form-group">
              <input type="text" name="serial" [(ngModel)]="filter.equipmentNumber" class="ir-form-set" />
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
  <div class="ir-modal--footer ir-position--b th-modal--footer">
    <div class="ir-row">
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="reset(form)">
          <span>{{ 'inspections.filter.reset-filters' | translate }}</span>
        </div>
      </div>
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <button class="ir-btn ir-btn--big ir-btn--block th-btn-remove ir-txt--right" type="submit" (click)="apply()">
          <span>{{ 'inspections.filter.apply-filters' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</form>
<modal (modalOutput)="selectLocalEntitiesMenu($event)" #localEntitiesModal></modal>
<modal (modalOutput)="selectPeopleMenu($event)" #peopleModal></modal>
<modal (modalOutput)="selectStatusMenu($event)" #statusModal></modal>
<modal (modalOutput)="selectProductLinesMenu($event)" #productLinesModal></modal>
<modal (modalOutput)="selectEquipmentTypeMenu($event)" #equipmentTypesModal></modal>
